"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircularProgress = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _reactNativeSvg = require("react-native-svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CircularProgress = function CircularProgress(props) {
  var size = props.size,
      strokeWidth = props.strokeWidth,
      text = props.text;
  var radius = (size - strokeWidth) / 2;
  var circum = radius * 2 * Math.PI;
  var svgProgress = 100 - props.progressPercent;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Svg, {
    width: size,
    height: size
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Circle, _extends({
    stroke: props.bgColor ? props.bgColor : "#f2f2f2",
    fill: "none",
    cx: size / 2,
    cy: size / 2,
    r: radius
  }, {
    strokeWidth: strokeWidth
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Circle, _extends({
    stroke: props.pgColor ? props.pgColor : "#3b5998",
    fill: "none",
    cx: size / 2,
    cy: size / 2,
    r: radius,
    strokeDasharray: "".concat(circum, " ").concat(circum),
    strokeDashoffset: radius * Math.PI * 2 * (svgProgress / 100),
    strokeLinecap: "round",
    transform: "rotate(-90, ".concat(size / 2, ", ").concat(size / 2, ")")
  }, {
    strokeWidth: strokeWidth
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    fontSize: props.textSize ? props.textSize : "10",
    x: size / 2,
    y: size / 2 + (props.textSize ? props.textSize / 2 - 1 : 5),
    textAnchor: "middle",
    fill: props.textColor ? props.textColor : "#333333"
  }, text));
};

exports.CircularProgress = CircularProgress;